export default "__VITE_ASSET__Dz_kU29G__"